module.exports = __webpack_public_path__ + "4285558f839b67072437a84177682cbf.png";